"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function Cart() {
  const {
    ref: mastheadRef,
    isVisible: mastheadVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: frameRef,
    isVisible: frameVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2103" id="cart-content" className="relative overflow-hidden bg-white py-28 md:py-36">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 top-16 select-none font-sans leading-none" style={{
      fontSize: "clamp(360px, 56vw, 760px)",
      WebkitTextStroke: "1px #000000",
      color: "transparent",
      opacity: 0.03
    }}>
        PW
      </div>

      <div className="relative mx-auto max-w-[1200px] px-5 md:px-8 lg:px-14">
        {}
        <div ref={mastheadRef} className={`transition-all duration-700 ease-out ${mastheadVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          {}
          <div className="flex items-center gap-3 font-sans text-[0.6875rem] uppercase tracking-[0.18em]">
            <span style={{
            color: "#e63946"
          }}>§ PROWHIP</span>
            <span style={{
            color: "#9ca3af"
          }}>— Your Order Summary</span>
          </div>

          {}
          <div className="relative mt-4 flex items-center">
            <div className="h-px flex-1" style={{
            backgroundColor: "#d1d5db"
          }} />
            <div className="ml-3 flex items-center gap-3">
              <span className="h-1 w-1 rounded-lg" style={{
              backgroundColor: "#e63946"
            }} />
              <span className="h-1 w-1 rounded-lg" style={{
              backgroundColor: "#e63946"
            }} />
              <span className="h-1 w-1 rounded-lg" style={{
              backgroundColor: "#e63946"
            }} />
            </div>
          </div>

          {}
          <h1 className="mt-10 font-sans text-black" style={{
          fontSize: "clamp(2.25rem, 4.8vw, 4.5rem)",
          fontWeight: 700,
          lineHeight: 1.02,
          letterSpacing: "-0.02em"
        }}>
            Review your{" "}
            <em className="font-sans italic" style={{
            color: "#e63946"
          }}>
              ProWhip
            </em>{" "}
            selection.
          </h1>

          {}
          <p className="mt-6 max-w-2xl font-sans text-lg leading-relaxed" style={{
          color: "#4b5563"
        }}>
            Confirm your premium cream chargers and accessories before finalizing your order. Quality and performance delivered to your kitchen.
          </p>
        </div>

        {}
        <div ref={frameRef} className={`relative mt-14 transition-all duration-700 ease-out ${frameVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          {}
          <span aria-hidden="true" className="pointer-events-none absolute -left-1 -top-1 h-[14px] w-[14px] md:h-[14px] md:w-[14px]" style={{
          borderTop: "1px solid #e63946",
          borderLeft: "1px solid #e63946"
        }} />
          <span aria-hidden="true" className="pointer-events-none absolute -right-1 -top-1 h-[14px] w-[14px]" style={{
          borderTop: "1px solid #e63946",
          borderRight: "1px solid #e63946"
        }} />
          <span aria-hidden="true" className="pointer-events-none absolute -bottom-1 -left-1 h-[14px] w-[14px]" style={{
          borderBottom: "1px solid #e63946",
          borderLeft: "1px solid #e63946"
        }} />
          <span aria-hidden="true" className="pointer-events-none absolute -bottom-1 -right-1 h-[14px] w-[14px]" style={{
          borderBottom: "1px solid #e63946",
          borderRight: "1px solid #e63946"
        }} />

          <div className="rounded-lg border border-gray-300 bg-white p-5 md:p-10 shadow-md">
            <WooCommerceCartBlock />
          </div>
        </div>
      </div>
    </section>;
}